import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { VirtualCardFilterStatus } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface VirtualCardStatusFilterProps {
  selectedStatuses?: Set<string>
  onToggleStatus: (status: string) => void
}

const VirtualCardStatusFilter: React.FC<VirtualCardStatusFilterProps> = ({
  selectedStatuses,
  onToggleStatus,
}): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      role="group"
      aria-labelledby="filter-card-status"
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        id="filter-card-status"
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Card Status')}
      </div>
      <Checkbox
        label={translate('Active')}
        testId="activeChk"
        onClick={(): void => onToggleStatus(VirtualCardFilterStatus.active)}
        isSelected={
          selectedStatuses?.has(VirtualCardFilterStatus.active) || false
        }
      />
      <Checkbox
        label={translate('Pending')}
        testId="pendingChk"
        onClick={(): void => onToggleStatus(VirtualCardFilterStatus.pending)}
        isSelected={
          selectedStatuses?.has(VirtualCardFilterStatus.pending) || false
        }
      />
      <Checkbox
        label={translate('Inactive')}
        testId="inactiveChk"
        onClick={(): void => onToggleStatus(VirtualCardFilterStatus.inactive)}
        isSelected={
          selectedStatuses?.has(VirtualCardFilterStatus.inactive) || false
        }
      />
      <Checkbox
        label={translate('Closed')}
        testId="closedChk"
        onClick={(): void => onToggleStatus(VirtualCardFilterStatus.closed)}
        isSelected={
          selectedStatuses?.has(VirtualCardFilterStatus.closed) || false
        }
      />
    </div>
  )
}

export default VirtualCardStatusFilter
